import { AppBar, Toolbar, Box, Grid } from "@mui/material";
import { AuthenticationButton } from "../common/auth/authenticationButton";


export interface HeaderProps {
  hideAuth?: boolean;
}

export function Header(props: HeaderProps) {
  return (
    <Box>
      <AppBar position="sticky" color="transparent">
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={8}>
              <Box
                height={80}
                component="img"
                src="/images/headerImage.png"
                alt=""
              />
            </Grid>
          </Grid>
          {!props.hideAuth && (
            <Grid container item xs={4} justifyContent="flex-end">
              <AuthenticationButton />
            </Grid>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
